import { createUseQueryHook } from '@iheartjane/react-query-utils';

import type { BrandSpecialQualifyingStatusProps } from './brandSpecial.api';
import { fetchBrandSpecialQualifyingStatus } from './brandSpecial.api';
import type { BrandSpecialQualifyingStatus } from './brandSpecial.types';

const queryKeys = {
  brandSpecialQualifyingStatus: (props: BrandSpecialQualifyingStatusProps) => [
    'stores',
    'brandSpecials',
    'qualifyingStatuses',
    String(props.storeId),
    String(props.specialId),
    String(props.cartUuid),
  ],
};

export const useBrandSpecialQualifyingStatus = createUseQueryHook<
  BrandSpecialQualifyingStatusProps,
  BrandSpecialQualifyingStatus
>(
  fetchBrandSpecialQualifyingStatus,
  queryKeys.brandSpecialQualifyingStatus,
  (props) => !!props.cartUuid && !!props.specialId && !!props.storeId
);
